import * as React from 'react'
import styled from 'styled-components'
import Box, {Row} from '../../atoms/Box'
import Image from '../../atoms/Image'
import { isMobile } from 'react-device-detect'
import {ExecutionResult} from 'graphql'
import {checkAllMoviesWatchedQuery} from '../../schema/schemaTypes'
import {CHECK_ALL_MOVIES_WATCHED_QUERY} from '../../queries/CHECK_ALL_MOVIES_WATCHED_QUERY'
import {apolloClient} from '../../utils/apolloClient'
import Swal from 'sweetalert2'

const langimg = process.env.REACT_APP_LANGUAGE === 'es' ? '_ES' : ''

// tslint:disable:max-line-length object-literal-sort-keys
const HomeImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

const Title = styled.h1`
  text-align: center;
  font-family: Nunito;
  font-weight: 900;
  font-size: 2rem !important;
  color: #043E74;
`

const TextContainer = styled.div`
    padding-left: 20px;
    position: relative;
    background: #C7F0F6;
    min-height: 500px;
    top: 20px;
    border-radius: 10px;
    padding-top: 30px;
    z-index: 1;
    box-shadow: 0 8px 40px 0 rgba(194, 111, 35, 0.2), 0 16px 80px 0 rgba(194, 111, 35, 0.2);
`

const GameName = styled.div`
  color: #2F358A;
  font-family: Nunito;
  font-size: 1.4rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.5rem;
`

const GameBox = styled(Box)`
  align-items: center;
  min-width: 215px;
  flex: 1;
  padding-bottom: 36px;

  @media (max-width: 600px) {
    min-width: 137px;
  }
`

const GameImage = styled(Image)`
  width: 210px;
  height: 215px;

  @media (max-width: 600px) {
    width: 137px;
    height: 140px;
  }
`

const Button = styled.div`
  :hover, :focus {
    text-decoration: underline;
  }
`
const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'


const translations = {
  'en': {
    activities: 'Activities',
    coloringPages: 'Coloring Pages',
    award: 'Award',
    video: 'Video',
  },
  'es': {
    activities: 'Actividades',
    coloringPages: 'Páginas para Colorear',
    award: 'Premio',
    video: 'Video',
  },
}

export class KidsActivitiesView extends React.Component {

  public async checkMoviesWatched() {
    const {data}: ExecutionResult<checkAllMoviesWatchedQuery> =
      await apolloClient.query<checkAllMoviesWatchedQuery>({
        query: CHECK_ALL_MOVIES_WATCHED_QUERY,
        fetchPolicy: 'network-only',
      }) as any
    if (data && data.CheckAllMoviesWatched) {
      (window as any).trackPrint('Award-Color.pdf', 'Kids Award')
      if (!isMobile) { window.open(`https://s3-us-west-1.amazonaws.com/uci-images/downloads/Award-Color${langimg}.pdf`) }
      // @ts-ignore
      if(window.ReactNativeWebView) {
        // @ts-ignore
        window.ReactNativeWebView.postMessage(JSON.stringify({
          name: 'downloadPdf',
          link: `https://s3-us-west-1.amazonaws.com/uci-images/downloads/Award-Color${langimg}.pdf`,
        }), '*')
      }
    } else {
      await Swal.fire({
        title: `<strong>${lang === 'es' ? '¡Ups! Necesita ver todas las películas!' : 'OOPS! NEED TO WATCH ALL THE MOVIES!'}</strong>`,
        cancelButtonText: 'OK',
        showConfirmButton: false,
        showCancelButton: true,
        focusCancel: false,
      })
    }
  }

  public render() {
    return (
      <div style={{position: 'relative'}}>
        <TextContainer>
          <div style={{position: 'relative', zIndex: 10}}>
            <Title>{translations[lang].activities}</Title>
            <Box style={{height: '1rem'}}/>
            <Row style={{flexWrap: 'wrap'}}>
              <GameBox>
                <Button onClick={() => {
                  (window as any).trackPrint('ColoringPages.pdf', 'Coloring Pages')
                  // @ts-ignore
                  if(window.ReactNativeWebView) {
                    // @ts-ignore
                    window.ReactNativWebView.postMessage(JSON.stringify({
                      name: 'downloadPdf',
                      link: `https://s3-us-west-1.amazonaws.com/uci-images/downloads/ColoringPages_ES${langimg}.pdf`,
                    }), '*')
                  }
                  if (!isMobile) { window.open(`https://s3-us-west-1.amazonaws.com/uci-images/downloads/ColoringPages${langimg}.pdf`) }
                }}>
                  <GameImage name="activityColoring"/>
                  <GameName>{translations[lang].coloringPages}</GameName>
                </Button>
              </GameBox>
              <GameBox>
                <Button onClick={() => {
                  (window as any).trackPrint('Activities-Color.pdf', 'Activities')
                  // @ts-ignore
                  if(window.ReactNativeWebView) {
                    // @ts-ignore
                    window.ReactNativeWebView.postMessage(JSON.stringify({
                      name: 'downloadPdf',
                      link: `https://s3-us-west-1.amazonaws.com/uci-images/downloads/Activities-Color${langimg}.pdf`,
                    }), '*')
                  }
                  if (!isMobile) { window.open(`https://s3-us-west-1.amazonaws.com/uci-images/downloads/Activities-Color${langimg}.pdf`) }
                }}>
                  <GameImage name="activityActivity"/>
                  <GameName>{translations[lang].activities}</GameName>
                </Button>
              </GameBox>
              <GameBox>
                <Button onClick={this.checkMoviesWatched}>
                  <GameImage name="activityAward"/>
                  <GameName>{translations[lang].award}</GameName>
                </Button>
              </GameBox>
            </Row>
          </div>
          <HomeImage
            id="image"
            src="https://s3-us-west-1.amazonaws.com/uci-images/images/kidsEmptyBackground.svg"
            alt=""/>
          <Box h={20}/>
        </TextContainer>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/organisms/KidsActivities/KidsActivitiesView.tsx